<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top> {{ text }} <v-btn color="pink" text  @click="msg = false"> Close</v-btn></v-snackbar>
        <ClientNav/>
        <v-row>
            <v-col cols="12" lg="3" xl="2">
                <ClientSide />
            </v-col>
            <v-col cols="12" lg="9" xl="10">

                <v-simple-table>
                    <template>
                        <thead>
                            <tr>
                                <th>
                                    
                                </th>
                                <th>
                                    1
                                </th>
                                <th>
                                    2
                                </th>
                                <th>
                                    3
                                </th>
                                <th>
                                    4
                                </th>
                                <th>
                                    5
                                </th>
                                <th>
                                    6
                                </th>
                                <th>
                                    7
                                </th>
                                <th>
                                    8
                                </th>
                                <th>
                                    9
                                </th>
                                <th>
                                    10
                                </th>
                                <th>
                                    11
                                </th>
                                <th>
                                    12
                                </th>
                                <th>
                                    13
                                </th>
                                <th>
                                    14
                                </th>
                                <th>
                                    15
                                </th>
                                


                            </tr>
                        </thead>
                        <tbody
                            v-for="hab in habs"
                            :key="hab._id"
                        >
                            <tr
                                v-for="steps in hab.Steps"
                                :key="steps.StepDescription"
                            >
                                {{steps.StepDescription}}
                                <td>
                                    
                                </td>
                                
                            </tr>

                            
                            
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import axios from 'axios'
import ClientNav from '../../components/ClientNav'
import ClientSide from '../../components/ClientSide'

const url = require("../../client_config/config").url;



export default {
    components: {
        ClientNav,
        ClientSide,
    },
    data: () => ({
        habs: [],
        clientID: this.$route.params.clientID
    }),

    created() {
        this.getHabPlan()
    },

    methods: {
        getHabPlan() {
            axios.get(`${url}/hab/plan/${this.clientID}`).then(res => {
                this.habs = res.data.habs
                console.log(this.habs)
            })
        }
    }
}

</script>